


















































































import Vue from "vue";
import store from "@/store";

// Interface
import { dialogOptions } from "@/interfaces/dialog.interface";
import {
  AddNewExercise,
  Exercise,
  ExerciseTags,
} from "@/interfaces/exercise.interface";
// Dialogs
import CreateNewExerciseDialog from "@/components/dialogs/CreateNewExerciseDialog.vue";

// Todo: Make it look better
// Todo: find where the list is being used
export default Vue.extend({
  data: () => ({
    ableToAddNewExercises: store.getters[
      "exerciseStore/getAllAddNewExercises"
    ] as AddNewExercise[],
    createExerciseDialog: false,
    exerciseTags: ["Push", "Pull", "Legs"] as ExerciseTags,
    tagSelection: "",
  }),
  props: {
    addNewExerciseDialog: Boolean,
    allowCreatingExercise: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addExercises() {
      let formattedExerciseList: Exercise[] = [];

      this.ableToAddNewExercises.forEach((exercise: any) => {
        if (exercise.exerciseName && exercise.type && exercise.wantToAdd) {
          let formattedExercise: Exercise = {
            bodyParts: exercise.bodyParts ? exercise.bodyParts : [],
            exerciseName: exercise.exerciseName,
            type: exercise.type,
            showExercise: true,
            wantExerciseNote: false,
            exerciseNote: "",
            sets: [],
          };
          formattedExerciseList.push(formattedExercise);
        }
      });

      if (formattedExerciseList.length > 0) {
        this.$emit("addExercises", formattedExerciseList);
        this.ableToAddNewExercises.forEach((exercise: AddNewExercise) => {
          exercise.wantToAdd = false;
        });
      }
    },
    updateExercise(value?: string) {
      if (value) {
        const selectedExerciseArray = value.split("(");
        const selectedExerciseName = selectedExerciseArray[0].slice(
          0,
          selectedExerciseArray[0].length - 1
        );
        const selectedExerciseType = selectedExerciseArray[1].slice(
          0,
          selectedExerciseArray[1].length - 1
        );

        // Todo: import type annotation
        this.ableToAddNewExercises.forEach((exercise: any) => {
          if (
            exercise.exerciseName === selectedExerciseName &&
            exercise.type === selectedExerciseType
          )
            exercise.wantToAdd = true;
        });

        // sorts want values in top
        let exerciseWantAdd: any[] = [];
        let exerciseNoAdd: any[] = [];
        this.ableToAddNewExercises.forEach((exercise: any) => {
          if (exercise.wantToAdd) exerciseWantAdd.push(exercise);
          else exerciseNoAdd.push(exercise);
        });

        exerciseWantAdd.concat(exerciseNoAdd);

        this.ableToAddNewExercises = exerciseWantAdd.concat(exerciseNoAdd);
      }
    },
    localDialogController(dialogToBeOpen: dialogOptions) {
      if (
        dialogToBeOpen === "createExerciseDialog" &&
        this.allowCreatingExercise
      )
        this.createExerciseDialog = true;
      if (dialogToBeOpen === "closeAll") this.createExerciseDialog = false;
    },
    dialogController(dialogToBeOpen: dialogOptions) {
      this.$emit("dialogController", dialogToBeOpen);
    },
  },
  computed: {
    selectableExerciseList() {
      let selectable: AddNewExercise[] =
        store.getters["exerciseStore/getAllAddNewExercises"];
      let modifiedList: any[] = [];
      selectable.forEach((exercise) => {
        let temp: any = exercise;
        temp.text = `${exercise.exerciseName} (${exercise.type})`;
        modifiedList.push(temp);
      });
      return modifiedList;
    },
    allExercises(): AddNewExercise[] {
      return store.getters["exerciseStore/getAllAddNewExercises"];
    },
  },
  watch: {
    // Todo: make this shorter by having one master method
    tagSelection() {
      this.ableToAddNewExercises = this.allExercises;
      if (this.tagSelection === "Push") {
        let hasBodyParts: AddNewExercise[] = [];
        this.ableToAddNewExercises.forEach((exercise) => {
          if (
            exercise.bodyParts.includes("Chest") ||
            exercise.bodyParts.includes("Shoulders") ||
            exercise.bodyParts.includes("Triceps") ||
            exercise.bodyParts.includes("Delts")
          )
            hasBodyParts.push(exercise);
        });
        this.ableToAddNewExercises = hasBodyParts;
      } else if (this.tagSelection === "Pull") {
        let hasBodyParts: AddNewExercise[] = [];
        this.ableToAddNewExercises.forEach((exercise) => {
          if (
            exercise.bodyParts.includes("Back") ||
            exercise.bodyParts.includes("Biceps") ||
            exercise.bodyParts.includes("Lats") ||
            exercise.bodyParts.includes("Lower Back")
          )
            hasBodyParts.push(exercise);
        });
        this.ableToAddNewExercises = hasBodyParts;
      } else if (this.tagSelection === "Legs") {
        let hasBodyParts: AddNewExercise[] = [];
        this.ableToAddNewExercises.forEach((exercise) => {
          if (
            exercise.bodyParts.includes("Legs") ||
            exercise.bodyParts.includes("Calves") ||
            exercise.bodyParts.includes("Quads") ||
            exercise.bodyParts.includes("Hamstrings")
          )
            hasBodyParts.push(exercise);
        });
        this.ableToAddNewExercises = hasBodyParts;
      }
    },
  },
  components: { CreateNewExerciseDialog },
});
